import {
  spawnCreateApiFunction,
  spawnGetApiFunction,
  spawnUpdateApiFunction,
  type ApiResourceConfig,
} from "@/utils/api";

const table = "maintenance_strategy_triggers";
export const query = "*";

export const apiConfigMaintenanceStrategyTriggers: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: [],
  sortables: [],
};

export const getMaintenanceStrategyTrigger = spawnGetApiFunction({ table, query });
export const createMaintenanceStrategyTrigger = spawnCreateApiFunction({ table, query });
export const updateMaintenanceStrategyTrigger = spawnUpdateApiFunction({ table, query });
